import { Component,Input,Output,EventEmitter, OnInit, AfterViewInit } from '@angular/core';
import { TranslateService } from 'ng2-translate';
@Component({
 selector: "dskl-wb-welcome",
  templateUrl: 'wb-welcome.component.html'
}) 
export class WelcomeWbComponent implements OnInit, AfterViewInit{
  ngAfterViewInit(){
    /*setTimeout(function(){
      window.location.reload();
    }, 5000);*/
  }
   ngOnInit() {
     var self = this;
       this.translate.get('WB_WELCOME.LOGO').subscribe((res: string) => {self.logo = res; });
   } 
  constructor(private translate: TranslateService){}
  pageName="Loading..."
  logo

}



// WEBPACK FOOTER //
// /app/src/app/wb/welcome/wb-welcome.component.ts